<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>导入批次</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="_queryBatches(1)">
              <i class="el-icon-refresh"></i>刷新
            </el-button>
          </div>
          <el-table ref="batchTable" :data="batchList" border style="width: 100%" v-loading="loading">
            <el-table-column prop="logId" label="批次号" align="center" width="180"></el-table-column>
            <el-table-column label="状态" align="center" width="90">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.state === 'W'" type="info" size="small">待处理</el-tag>
                <el-tag v-else-if="scope.row.state === 'D'" type="warning" size="small">处理中</el-tag>
                <el-tag v-else-if="scope.row.state === 'C'" type="success" size="small">完成</el-tag>
                <span v-else>{{ scope.row.state || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="successCount" label="成功" align="center" width="70"></el-table-column>
            <el-table-column prop="errorCount" label="失败" align="center" width="70"></el-table-column>
            <el-table-column prop="skipCount" label="跳过" align="center" width="70"></el-table-column>
            <el-table-column label="图片未匹配" align="center" width="110">
              <template slot-scope="scope">
                <el-link v-if="_imageMissList(scope.row).length > 0" type="warning"
                  @click="_openImageMiss(scope.row)">{{ _imageMissList(scope.row).length }}张未匹配</el-link>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="转存状态" align="center" width="90">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.transferState === 'W'" type="warning" size="small">转存中</el-tag>
                <el-tag v-else-if="scope.row.transferState === 'C'" type="success" size="small">转存完成</el-tag>
                <el-tag v-else-if="scope.row.transferState === 'F'" type="danger" size="small">转存失败</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" width="170"></el-table-column>
            <el-table-column label="操作" align="center" min-width="220">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openDetail(scope.row)">详情</el-button>
                <el-button size="mini" type="primary" @click="_goAudit(scope.row)">去审核</el-button>
                <el-button size="mini" type="danger" @click="_offShelfBatch(scope.row)">整批下架</el-button>
              </template>
            </el-table-column>
            <template slot="empty">
              <span>暂无导入批次，请先在「商品导入」页提交导入</span>
            </template>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图片未匹配清单 -->
    <el-dialog title="图片未匹配清单" :visible.sync="imageMissDialog.show" width="600px">
      <el-alert type="warning" :closable="false"
        :title="'以下封面图在 zip 压缩包中未找到：' + imageMissDialog.list.join('、')">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageMissDialog.show = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 批次详情抽屉 -->
    <el-drawer :title="'批次详情（批次号：' + detail.drawerLogId + '）'" :visible.sync="detail.drawer" size="60%">
      <div class="drawer-body">
        <el-row :gutter="20" class="state-dist">
          <el-col :span="6">
            <div class="dist-item info">
              <div class="num">{{ detail.stateDist.W || 0 }}</div>
              <div class="label">待导入</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="dist-item success">
              <div class="num">{{ detail.stateDist.C || 0 }}</div>
              <div class="label">成功</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="dist-item danger">
              <div class="num">{{ detail.stateDist.F || 0 }}</div>
              <div class="label">失败</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="dist-item warning">
              <div class="num">{{ detail.stateDist.S || 0 }}</div>
              <div class="label">跳过</div>
            </div>
          </el-col>
        </el-row>

        <div class="flex justify-between detail-filter">
          <el-select v-model="detail.state" placeholder="全部状态" clearable size="small" @change="_queryDetail(1)"
            style="width: 160px">
            <el-option label="待导入" value="W"></el-option>
            <el-option label="成功" value="C"></el-option>
            <el-option label="失败" value="F"></el-option>
            <el-option label="跳过" value="S"></el-option>
          </el-select>
        </div>

        <el-table :data="detail.list" border style="width: 100%" v-loading="detail.loading">
          <el-table-column prop="detailId" label="明细ID" align="center" width="180"></el-table-column>
          <el-table-column label="状态" align="center" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.state === 'W'" type="info" size="small">待导入</el-tag>
              <el-tag v-else-if="scope.row.state === 'C'" type="success" size="small">成功</el-tag>
              <el-tag v-else-if="scope.row.state === 'F'" type="danger" size="small">失败</el-tag>
              <el-tag v-else-if="scope.row.state === 'S'" type="warning" size="small">跳过</el-tag>
              <span v-else>{{ scope.row.state || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="处理信息" align="center"></el-table-column>
          <el-table-column prop="createTime" label="时间" align="center" width="170"></el-table-column>
        </el-table>
        <el-pagination @current-change="handleDetailPageChange" :current-page="detail.page" :page-size="20"
          layout="total, prev, pager, next" :total="detail.total" class="pagination"></el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { queryImportBatches, queryImportBatchDetail, batchOffShelfByImport } from '@/api/goods/importBatchApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  name: 'ImportBatchManage',
  components: {
    AdminShop
  },
  data() {
    return {
      shopId: '',
      batchList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      imageMissDialog: {
        show: false,
        list: []
      },
      detail: {
        drawer: false,
        drawerLogId: '',
        state: '',
        stateDist: {},
        list: [],
        page: 1,
        total: 0,
        loading: false
      }
    }
  },
  created() {
    // 首屏跟随左侧店铺选择器的初始态（"全部"，shopId=''）。
    // 不读 getShopId()：那是其他页面残留的上次选中店铺，会导致"全部"高亮却按残留店铺过滤的空列表
    this._queryBatches(1)
  },
  methods: {
    handleShopChange(shop) {
      this.shopId = shop.shopId
      this._queryBatches(1)
    },
    async _queryBatches(page) {
      // 运营身份：shopId 为空或 -1（未选店铺的默认值）= 查全部门店；选中具体店铺则过滤
      this.loading = true
      try {
        const params = {
          page: page,
          row: this.pageSize
        }
        if (this.shopId && this.shopId !== '-1') {
          params.shopId = this.shopId
        }
        const res = await queryImportBatches(params)
        // ResultVo 契约：records=总页数 total=总记录数 data=列表
        this.batchList = (res && res.data) || []
        this.total = (res && res.total) || 0
        this.currentPage = page
        // 页签框架预渲染后容器宽度可能变化，数据到达后强制重排表格，避免表头表体错位
        this.$nextTick(() => {
          if (this.$refs.batchTable) {
            this.$refs.batchTable.doLayout()
          }
        })
      } catch (error) {
        console.error('查询导入批次失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this._queryBatches(val)
    },
    _imageMissList(row) {
      if (!row || !row.imageMissJson) {
        return []
      }
      if (typeof row.imageMissJson === 'string') {
        try {
          const arr = JSON.parse(row.imageMissJson)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      }
      return Array.isArray(row.imageMissJson) ? row.imageMissJson : []
    },
    _openImageMiss(row) {
      this.imageMissDialog = {
        show: true,
        list: this._imageMissList(row)
      }
    },
    async _openDetail(row) {
      this.detail.drawer = true
      this.detail.drawerLogId = row.logId
      this.detail.state = ''
      await this._queryDetail(1)
    },
    async _queryDetail(page) {
      this.detail.loading = true
      try {
        const params = {
          logId: this.detail.drawerLogId,
          page: page,
          row: 20,
          shopId: this.shopId
        }
        if (this.detail.state) {
          params.state = this.detail.state
        }
        const res = await queryImportBatchDetail(params)
        // api 层已解包一层，res 即 {details, stateDist}（自定义结构，非 ResultVo.data）
        const data = res || {}
        this.detail.stateDist = data.stateDist || {}
        const details = data.details || {}
        this.detail.list = details.data || details.list || []
        this.detail.total = details.total || 0
        this.detail.page = page
      } catch (error) {
        console.error('查询批次明细失败:', error)
      } finally {
        this.detail.loading = false
      }
    },
    handleDetailPageChange(val) {
      this._queryDetail(val)
    },
    _goAudit(row) {
      this.$router.push('/pages/goods/adminProduct?importLogId=' + row.logId)
    },
    _offShelfBatch(row) {
      this.$confirm('确认下架该批次导入的全部商品？', '整批下架', {
        confirmButtonText: '确认下架',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await batchOffShelfByImport({
            importLogId: row.logId,
            shopId: this.shopId
          })
          if (res.code === 0) {
            this.$message.success('下架成功')
            this._queryBatches(this.currentPage)
            // 通知 layout 立即刷新审核待办角标，不等 60s 轮询
            window.dispatchEvent(new Event('mall-audit-todo-changed'))
          } else {
            this.$message.error(res.msg || '下架失败')
          }
        } catch (error) {
          console.error('整批下架失败:', error)
          this.$message.error('下架失败')
        }
      }).catch(() => {
        // 取消
      })
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.box-card {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}

.drawer-body {
  padding: 0 20px 20px;
}

.state-dist {
  text-align: center;
  margin-bottom: 20px;
}

.dist-item {
  border-radius: 4px;
  padding: 14px 0;
  background: #f5f7fa;
}

.dist-item .num {
  font-size: 26px;
  font-weight: bold;
  line-height: 1.4;
}

.dist-item .label {
  font-size: 13px;
  color: #909399;
}

.dist-item.info .num {
  color: #909399;
}

.dist-item.success .num {
  color: #67C23A;
}

.dist-item.danger .num {
  color: #F56C6C;
}

.dist-item.warning .num {
  color: #E6A23C;
}

.detail-filter {
  margin-bottom: 10px;
}
</style>
